__turbopack_context__.v({
  "external-link": "section-of-faqs-module-scss-module__Mc1U4q__external-link",
  "header": "section-of-faqs-module-scss-module__Mc1U4q__header",
  "heading": "section-of-faqs-module-scss-module__Mc1U4q__heading",
  "hr": "section-of-faqs-module-scss-module__Mc1U4q__hr",
  "item": "section-of-faqs-module-scss-module__Mc1U4q__item",
  "paragraph": "section-of-faqs-module-scss-module__Mc1U4q__paragraph",
  "section": "section-of-faqs-module-scss-module__Mc1U4q__section",
});
